import { useState } from 'react';
import { useJobs } from '@/hooks/useJob';
import { Spinner, EmptyState, Pagination } from '@/components/common';
import JobCard from '@/components/card/JobCard';
import { useAuthStore } from '@/store/authStore';
import { PERMISSIONS } from '@/routes/guards';
import { JobFilter } from '@/components/jobs/JobFilter';
import { cn } from '@/lib/utils';

export default function JobListPage() {
  const { user } = useAuthStore();
  const isHeadhunter = !!user && PERMISSIONS.canCreateJob(user?.role);

  const [filters, setFilters] = useState<any>({
    page: 1,
    limit: 12,
    approvalStatus: isHeadhunter ? undefined : 'approved',
    orderBy: 'createdAt',
    orderDirection: 'DESC'
  });

  const { data, isLoading, isFetching } = useJobs(filters);

  const handleFilterSearch = (searchFilters: any) => {
    setFilters((prev: any) => {
      const newFilters = { ...prev, ...searchFilters, page: 1 };
      // Omit undefined/null values to keep the object clean
      return Object.fromEntries(
        Object.entries(newFilters).filter(([_, v]) => v !== undefined && v !== null)
      );
    });
  };

  const total = data?.total ?? 0;
  const totalPages = Math.ceil(total / (filters.limit || 12));

  return (
    <div className="pb-20">
      {/* Header */}
      <div className="mb-6">
        <div className="section-label">Việc làm</div>
        <div className="flex items-end justify-between">
          <h1 className="section-title mb-0">Danh sách việc làm</h1>
          {total > 0 && (
            <span className="text-sm" style={{ color: 'var(--text-3)' }}>
              {total} kết quả
            </span>
          )}
        </div>
      </div>

      {/* New TopCV-style Filter */}
      <div className="sticky top-[104px] z-30 mb-8">
        <JobFilter onSearch={handleFilterSearch} initialFilters={filters} />
      </div>

      {/* Job cards */}
      {isLoading ? (
        <Spinner />
      ) : !data?.data?.length ? (
        <EmptyState title="Không tìm thấy việc làm" description="Thử thay đổi bộ lọc" icon="💼" />
      ) : (
        <>
          <div className={cn('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 transition-opacity', isFetching && 'opacity-60')}>
            {data?.data?.map((job: any) => (
              <JobCard key={job.id} job={job} />
            ))}
          </div>
          <Pagination
            page={filters.page}
            totalPages={totalPages}
            onChange={(p) => setFilters((f: any) => ({ ...f, page: p }))}
          />
        </>
      )}
    </div>
  );
}
